import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import extractText from 'flarum/common/utils/extractText';
import LangDisplayName from '../../common/utils/LangDisplayName';
import TranslationMeta from './TranslationMeta';
/**
 * Strip above a poll whose texts are swapped for a translation, with the
 * "Show original" toggle.
 */
export default class PollTranslationNotice extends Component {
  view() {
    const {
      state
    } = this.attrs;
    const translation = state.active();
    const to = LangDisplayName(state.language ?? '');
    if (!translation) {
      return m("div", {
        className: "PollTranslationNotice"
      }, m(LoadingIndicator, {
        display: "inline",
        size: "small"
      }), m("span", null, app.translator.trans('fof-translate.forum.translation.loading_text', {
        to
      })));
    }
    const source = translation.sourceLanguage() || this.attrs.source;
    const refreshLabel = extractText(app.translator.trans('fof-translate.forum.translation.refresh_button'));
    return m("div", {
      className: "PollTranslationNotice"
    }, m("span", {
      className: "PollTranslationNotice-title"
    }, source ? app.translator.trans('fof-translate.forum.translation.header_from', {
      from: LangDisplayName(source),
      to
    }) : app.translator.trans('fof-translate.forum.translation.header_to', {
      to
    })), m(TranslationMeta, {
      provider: translation.provider(),
      updatedAt: translation.updatedAt()
    }), m(Button, {
      className: "Button Button--link PollTranslationNotice-original",
      icon: "fas fa-undo",
      onclick: () => state.close()
    }, app.translator.trans('fof-translate.forum.poll.show_original_button')), app.forum.attribute('fof-translate.canRefresh') && m(Button, {
      className: "Button Button--icon Button--link PollTranslationNotice-refresh",
      icon: "fas fa-sync",
      "aria-label": refreshLabel,
      title: refreshLabel,
      loading: state.loading,
      disabled: state.loading,
      onclick: () => state.refresh()
    }));
  }
}
flarum.reg.add('fof-translate', 'forum/components/PollTranslationNotice', PollTranslationNotice);